import { KeyValuePipe } from '@angular/common';
import { Component, inject, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatChipGrid, MatChipInput, MatChipRemove, MatChipRow, MatChipSet } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatOption, MatSelect, MatSelectTrigger } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, EMPTY } from 'rxjs';

@Component({
  selector: 'app-ngx-crud-export',
  imports: [
    FormsModule,
    KeyValuePipe,
    MatButton,
    MatChipRemove,
    MatChipRow,
    MatChipSet,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatFormField,
    MatIcon,
    MatOption,
    MatSelect,
    MatSelectTrigger,
  ],
  templateUrl: './ngx-crud-export.component.html',
  styleUrl: './ngx-crud-export.component.scss'
})
export class NgxCrudExportComponent {

  private readonly data = inject(MAT_DIALOG_DATA);

  columns = signal<Record<string, string>>(this.data.columns);

  service = signal(this.data.service);

  selectedColumns = model<string[]>(this.getColumnKeysFrom(this.data.columns) || []);

  private readonly snackBar = inject(MatSnackBar);

  private readonly matDialogRef = inject(MatDialogRef<NgxCrudExportComponent>);

  getColumnKeysFrom(dict) {
    return Object.keys(dict);
  }

  removeColumn(columnKey: string) {
    this.selectedColumns.update(columns => {
      const index = columns.indexOf(columnKey);
      if (index < 0) {
        return columns;
      }

      columns.splice(index, 1);
      return [...columns];
    });
  }

  addColumn(columnKey: string) {
    this.selectedColumns.update(columns => {
      if (columns.includes(columnKey)) {
        return columns;
      }

      columns.push(columnKey);
      return [...columns];
    });
  }

  export() {
    this.service().export(this.selectedColumns()).pipe(
      catchError(() => {
        this.snackBar.open('Error al exportar data', 'Cerrar', {
          duration: 3000,
          panelClass: ['snackbar-error']
        });

        return EMPTY;
      }),
    )
    .subscribe((response) => {
      if (response) {
        this.matDialogRef.close(true);
      } else {
        this.matDialogRef.close(false);
      }
    });
  }
}
